import useSWRImmutable from 'swr/immutable'
import {GRAPH_NODE_EXCHANGE_SUBGRAPH_URL} from '@pancakeswap/address-config'
import BigNumber from 'bignumber.js'
import { BIG_ZERO } from './bigNumber'

export const GraphNodeBaseUrl:string =  process.env.NEXT_PUBLIC_ENV === 'main' ? 'https://agni.finance/graph/subgraphs/name' : 'https://testnet.agni.finance/graph/subgraphs/name'

export const useCakePrice = () => {
  return useSWRImmutable(
    ['cake-usd-price'],
    async () => {
      // const cake = await (await fetch('https://farms-api.pancakeswap.com/price/cake')).json()
      const graphCakePrice = await (
        await fetch(GRAPH_NODE_EXCHANGE_SUBGRAPH_URL, {
          body: '{"query":"{\\n  token(id: \\"0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc\\") {\\n    derivedETH\\n    derivedUSD\\n    name\\n  }\\n  bundles {\\n    ethPriceUSD\\n  }\\n}","variables":null,"extensions":{"headers":null}}',
          method: 'POST',
        })
      ).json()

      const cakePrice = BigNumber(graphCakePrice?.data?.bundles?.[0]?.ethPriceUSD)
        .multipliedBy(graphCakePrice?.data?.token?.derivedETH)
        .toString()

      return cakePrice as string
    },
    {
      refreshInterval: 1_000 * 10,
    },
  )
}

// for migration to bignumber.js to avoid breaking changes
export const useCakePriceAsBN = () => {
  const { data } = useSWRImmutable(
    ['cake-usd-price-bn'],
    async () => {
      // const cake = await (await fetch('https://farms-api.pancakeswap.com/price/cake')).json()
      const graphCakePrice = await (
        await fetch(GRAPH_NODE_EXCHANGE_SUBGRAPH_URL, {
          body: '{"query":"{\\n  token(id: \\"0xf6762afb45ac0af7ddc5aa92b885c6ece57874dc\\") {\\n    derivedETH\\n    derivedUSD\\n    name\\n  }\\n  bundles {\\n    ethPriceUSD\\n  }\\n}","variables":null,"extensions":{"headers":null}}',
          method: 'POST',
        })
      ).json()

      let cakePrice = BigNumber(graphCakePrice?.data?.bundles?.[0]?.ethPriceUSD)
        .multipliedBy(graphCakePrice?.data?.token?.derivedETH)
        .toString()
      if (cakePrice === 'NaN'){
        cakePrice = '0'
      }
      return new BigNumber(cakePrice)
    },
    {
      compare: (a, b) => {
        if (!a && !b) return true
        if (!a || !b) return false
        return a.eq(b)
      },
      refreshInterval: 1_000 * 10,
    },
  )

  return data ?? BIG_ZERO
}
